export const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '韩漫网',
  alternateName: 'ManHuaKR',
  url: 'https://www.manhuakr.com',
  description: '韩漫网提供免费韩国漫画大全和好看韩漫推荐，支持在线阅读，您能轻松发现热门作品并沉浸其中。',
  email: 'contact@manhuakr.com',
  foundingDate: '2024',
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer service',
    email: 'contact@manhuakr.com',
    availableLanguage: ['Chinese'],
  },
};

export function getWebSiteSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '韩漫网',
    alternateName: 'ManHuaKR - 免费韩国漫画在线阅读',
    url: 'https://www.manhuakr.com',
    description: '韩漫网提供免费韩国漫画大全和好看韩漫推荐，支持在线阅读。',
    potentialAction: {
      '@type': 'SearchAction',
      'target': {
        '@type': 'EntryPoint',
        urlTemplate: 'https://www.manhuakr.com/search?q={search_term_string}',
      },
      'query-input': 'required name=search_term_string',
    },
    inLanguage: 'zh-CN',
  };
}

export function getWebPageSchema(title: string, description: string, url: string) {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: title,
    description: description,
    url: url,
    inLanguage: 'zh-CN',
    isPartOf: {
      '@type': 'WebSite',
      name: '韩漫网',
      url: 'https://www.manhuakr.com',
    },
    about: {
      '@type': 'Organization',
      name: '韩漫网',
    },
  };
}

export function getBreadcrumbSchema(items: { name: string; item?: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.item || undefined,
    })),
  };
}

export function getComicArticleSchema(
  title: string,
  description: string,
  url: string,
  imageUrl: string,
  author: string,
  datePublished: string,
) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: title,
    description: description,
    image: imageUrl,
    author: {
      '@type': 'Person',
      name: author,
    },
    datePublished: datePublished,
    dateModified: datePublished,
    publisher: {
      '@type': 'Organization',
      name: '韩漫网',
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': url,
    },
    inLanguage: 'zh-CN',
  };
}

export function getFAQSchema(faqs: { question: string; answer: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };
}

export function getCollectionPageSchema(name: string, description: string, url: string) {
  return {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: name,
    description: description,
    url: url,
    inLanguage: 'zh-CN',
    isPartOf: {
      '@type': 'WebSite',
      name: '韩漫网',
      url: 'https://www.manhuakr.com',
    },
  };
}